{
  "greeting": {
    "salam": "Assalamu alaikum",
    "salamWithName": "Assalamu alaikum, {{name}}"
  },
  "dock": {
    "saved": "Salvati",
    "savedVerses": "Versetti salvati",
    "tasks": "Attività",
    "notes": "Note"
  },
  "actions": {
    "save": "Salva",
    "cancel": "Annulla",
    "close": "Chiudi",
    "delete": "Elimina",
    "rename": "Rinomina",
    "dismiss": "Ignora",
    "loading": "Caricamento…",
    "reload": "Ricarica",
    "retry": "Riprova",
    "expand": "Espandi",
    "collapse": "Comprimi"
  },
  "nav": {
    "appNavigation_aria": "Navigazione dell'app"
  },
  "tabs": {
    "home": "Home",
    "tasks": "Attività",
    "notes": "Note",
    "more": "Altro"
  },
  "more": {
    "daily": "Giornaliero",
    "account": "Account",
    "savedVerses": "Versetti salvati",
    "qibla": "Qibla",
    "prayerTimes": "Orari di preghiera e promemoria",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Gestito tramite il tuo account Rhemn",
    "upgrade": "Passa a Pro",
    "privacyPolicy": "Informativa sulla privacy",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Indietro",
    "deleteAccount": "Elimina account"
  },
  "reflection": {
    "dismiss_aria": "Ignora riflessione"
  },
  "app": {
    "loading_aria": "Rhemn si sta caricando",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Gestisci il tuo abbonamento Rhemn Pro sul web. Pro si sblocca automaticamente qui quando accedi con l'account abbonato."
  },
  "header": {
    "qiblaDirection_aria": "Direzione della Qibla",
    "prayerTimes_aria": "Orari delle preghiere",
    "prayerTimesTitle": "Orari delle preghiere",
    "method": "Metodo",
    "methodHelp": "Il metodo influisce sugli orari calcolati"
  },
  "search": {
    "search_aria": "Cerca",
    "searchLabel": "Cerca",
    "searchWeb_placeholder": "Cerca sul web"
  },
  "focus": {
    "input_placeholder": "Cosa conta di più oggi?",
    "example_worship": "Pregare con presenza, senza fretta",
    "example_kindness": "Chiamare mia madre solo per ascoltarla",
    "example_reflect": "Riflettere sull'intenzione con il versetto di oggi",
    "saveIntention_aria": "Salva intenzione",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Profilo",
    "profileAndAccount_aria": "Profilo e account",
    "profileDialog_aria": "Profilo",
    "editName_aria": "Modifica il tuo nome",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Gestisci abbonamento",
    "manageSubscription_aria": "Gestisci il tuo abbonamento Rehmn Pro",
    "anonymousAnalytics": "Analisi anonime",
    "anonymousAnalyticsNote": "Solo aggregate — mai collegate a te",
    "shareAnalytics_aria": "Condividi analisi d'uso anonime",
    "signOut": "Esci",
    "signingOut": "Disconnessione…",
    "signOut_aria": "Esci da Rehmn",
    "restorePurchases": "Ripristina acquisti",
    "restorePurchases_aria": "Ripristina gli acquisti precedenti"
  },
  "background": {
    "loading": "Caricamento sfondo...",
    "fallbackNotice": "Uso di un'immagine di riserva (API Unsplash non disponibile)",
    "noImage": "Nessuna immagine di sfondo disponibile",
    "error": "Errore: {{message}}",
    "photoByOnUnsplash": "Foto di <photographer>{{name}}</photographer> su <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Qualcosa è andato storto",
    "fallbackMessage": "Si è verificato un errore imprevisto."
  },
  "theme": {
    "switchToLight_title": "Passa alla modalità chiara",
    "switchToDark_title": "Passa alla modalità scura"
  },
  "upgradeCta": {
    "upgradeToPro": "Passa a Pro",
    "restorePurchases": "Ripristina acquisti",
    "restoring": "Ripristino…",
    "restoreEmpty": "Nessun acquisto trovato.",
    "pricePerMonth": "{{price}} / mese",
    "pricePerYear": "{{price}} / anno",
    "purchasePending": "In attesa di approvazione. Pro si attiverà automaticamente una volta approvato l'acquisto.",
    "storeUnavailable": "Al momento l'App Store non è raggiungibile. Riprova tra un istante.",
    "purchaseFailed": "Non è stato possibile completare l'acquisto. Riprova tra un istante."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · 25% di sconto sul primo anno",
    "title": "Per le ore tra le tue preghiere.",
    "body": "Note vocali che vengono trascritte, riassunte e trasformate in attività. Un planner della giornata costruito attorno agli orari delle tue preghiere. Note con l'IA.",
    "price": "$29.99",
    "period": "per il primo anno",
    "priceIos": "25% di sconto sul primo anno",
    "terms": "Poi $39.99 all'anno. Il codice {{code}} è già applicato.",
    "termsIos": "Si rinnova al normale prezzo annuale. Usa il codice {{code}} nell'App Store.",
    "free": "Orari di preghiera, Qibla, versetto del giorno e attività restano gratuiti.",
    "cta": "Passa a Pro",
    "dismiss": "Non ora"
  },
  "planChooser": {
    "monthly": "Mensile",
    "yearly": "Annuale",
    "yearlyValue": "Quattro mesi offerti da noi.",
    "freeNote": "Orari di preghiera, Qibla, versetto del giorno e attività sono gratuiti. Rhemn Pro aggiunge:",
    "includes_planner": "Una giornata costruita attorno alle cinque preghiere, e «Pianifica la mia giornata»",
    "includes_insights": "Quran Insights — fai una domanda su qualsiasi versetto e leggine il contesto",
    "includes_reflections": "Riflessioni sul versetto del giorno, scritte per l'intenzione che hai fissato",
    "includes_notes": "Note e note vocali, con riepiloghi e riordino AI",
    "includes_extras": "Versetti salvati, schede versetto, serie e previsioni a 5 giorni",
    "renewsMonthly": "Si rinnova ogni mese fino alla disdetta",
    "renewsYearly": "Si rinnova ogni 12 mesi fino alla disdetta",
    "continue": "Continua",
    "renewalTerms": "Il pagamento viene addebitato sul tuo Apple ID alla conferma. L'abbonamento si rinnova automaticamente se il rinnovo automatico non viene disattivato almeno 24 ore prima della fine del periodo. Gestisci o disdici quando vuoi nelle impostazioni Apple ID.",
    "retry": "Riprova"
  },
  "streak": {
    "badge_aria": "Serie giornaliera — {{count}} giorni",
    "title": "Serie giornaliera",
    "daysWithCount": "Serie di {{count}} giorni",
    "start": "Inizia oggi — dedica un momento al versetto o segna una preghiera.",
    "prayedToday": "Ho pregato oggi",
    "readVerse": "Ho letto il versetto di oggi",
    "autoHint": "Il versetto si segna da solo quando gli dedichi un momento.",
    "milestoneTitle": "{{count}} giorni di intenzione",
    "milestoneBody": "Alhamdulillah. Condividi il traguardo — qualcuno a cui vuoi bene potrebbe iniziare a sua volta.",
    "share": "Condividi",
    "dismiss": "Non ora",
    "cardLabel": "giorni di intenzione",
    "shareCaption": "{{count}} giorni iniziati con intenzione — rhemn.com",
    "imageSaved": "Immagine salvata.",
    "couldNotCreateImage": "Impossibile creare l'immagine. Riprova."
  },
  "qibla": {
    "compassIcon_aria": "Icona bussola",
    "title": "Direzione della Qibla",
    "locationUnavailable": "Posizione non disponibile",
    "locating": "Localizzazione…",
    "compass_aria": "Bussola Qibla",
    "directionN": "N",
    "directionE": "E",
    "directionS": "S",
    "directionW": "O",
    "facingQibla": "Rivolto verso la Qibla",
    "enableLiveCompass": "Attiva bussola in tempo reale",
    "enableLiveCompassNote": "Usa il sensore di movimento così la freccia segue i tuoi spostamenti — non la posizione",
    "directionToMecca": "Direzione verso La Mecca",
    "enableLocation": "Attiva l'accesso alla posizione per calcolare la direzione",
    "hintLive": "La freccia segue l'orientamento del dispositivo in tempo reale",
    "hintStatic": "Rilevamento dal Nord — usa con una bussola per una direzione precisa",
    "live": "In diretta",
    "footerVerse": "\"Volgi dunque il tuo viso verso la Sacra Moschea\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Note legali",
    "termsOfUse": "Condizioni d'uso",
    "privacyPolicy": "Informativa sulla privacy"
  },
  "auth": {
    "signInForPro": "Accedi prima: il tuo Pro ti segue ovunque."
  },
  "integrations": {
    "row": {
      "label": "Calendari e attività",
      "caption": "Connesso",
      "subNone": "Non connesso",
      "subFree": "Google Calendar, Google Tasks e altro",
      "subAttention": "{{provider}} richiede attenzione",
      "subPaused": "Sincronizzazione in pausa"
    },
    "list": {
      "title": "Calendari e attività",
      "subtitle": "Porta riunioni e attività nella tua giornata.",
      "footnote": "Rhemn legge solo ciò che serve e non memorizza mai i tuoi eventi.",
      "privacy": "Informativa sulla privacy",
      "connect": "Connetti",
      "connect_aria": "Connetti {{what}}",
      "checking": "Verifica…",
      "loadError": "Impossibile caricare le tue connessioni.",
      "tryAgain": "Riprova",
      "offline": "Sei offline. Connettiti quando torni online.",
      "unavailable": "Calendari e attività non sono disponibili al momento.",
      "disconnected": "{{provider}} disconnesso.",
      "google": {
        "name": "Google",
        "sub": "Calendar e Tasks",
        "what": "Google Calendar e Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Attività e progetti",
        "what": "Todoist"
      },
      "apple": {
        "name": "Calendario e Promemoria",
        "subNative": "Su questo {{device}}",
        "subSafari": "Nell'app Rhemn per iPhone e Mac"
      },
      "synced": "Sincronizzato {{when}}",
      "connectedSub": "Connesso",
      "syncing": "Sincronizzazione…",
      "reconnectSub": "Riconnetti per continuare a sincronizzare",
      "errorSub": "L'ultima sincronizzazione non è andata a buon fine",
      "pausedSub": "In pausa · Rhemn Pro è terminato"
    },
    "explainer": {
      "google": {
        "title": "Connetti Google Calendar e Tasks",
        "p1Lead": "Il tuo calendario, in sola lettura",
        "p1Body": "Rhemn mostra i tuoi eventi nella giornata e vede quando sei impegnato. Non li memorizza.",
        "p2Lead": "Google Tasks, in entrambe le direzioni",
        "p2Body": "Le liste che scegli restano sincronizzate, così puoi spuntarle ovunque.",
        "p3Lead": "Puoi annullare quando vuoi",
        "p3Body": "Disconnetti in qualsiasi momento, qui o nel tuo Account Google.",
        "footnote": "Google ti mostrerà esattamente cosa richiede Rhemn."
      },
      "todoist": {
        "title": "Connetti Todoist",
        "p1Lead": "I tuoi progetti, in entrambe le direzioni",
        "p1Body": "I progetti che scegli restano sincronizzati, così puoi spuntarli ovunque.",
        "p2Lead": "Come vengono mappate",
        "p2Body": "Le priorità di Todoist diventano Critica, Alta, Media e Bassa. I sotto-task oltre il primo livello appaiono come passaggi sotto l'attività principale.",
        "p3Lead": "Puoi annullare quando vuoi",
        "p3Body": "Disconnetti in qualsiasi momento, qui o nelle impostazioni di Todoist.",
        "cta": "Continua su Todoist",
        "footnote": "Todoist ti chiederà una conferma."
      },
      "skip": "Non ora",
      "cancel": "Annulla",
      "waiting": "In attesa di {{provider}}…",
      "safariWaiting": "Completa nella nuova scheda, poi torna qui.",
      "safariReopen": "Riapri la scheda",
      "denied": "{{provider}} non ha concesso l'accesso, quindi non è stato connesso nulla.",
      "error": "Impossibile connettersi a {{provider}}. Riprova tra poco."
    },
    "detail": {
      "back_aria": "Torna a Calendari e attività",
      "syncNow": "Sincronizza ora",
      "intro": "Scegli cosa sincronizza Rhemn. Puoi cambiarlo in qualsiasi momento.",
      "taskLists": "Liste di attività",
      "projects": "Progetti",
      "reminders": "Promemoria",
      "calendars": "Calendari",
      "rhemnCalendarSub": "I tuoi orari di preghiera, non contati come impegni",
      "loading": "Caricamento…",
      "loadError": "Impossibile caricare le tue liste.",
      "emptyGoogle": "Nessuna lista di attività in Google Tasks.",
      "emptyTodoist": "Nessun progetto in Todoist.",
      "addError": "Impossibile aggiungere {{name}}. Riprova.",
      "removed": "Rimosso da Rhemn. È ancora presente in {{provider}}.",
      "undo": "Annulla",
      "prayerTimes": "Aggiungi gli orari di preghiera al tuo calendario",
      "prayerTimesSub": "Aggiunge le cinque preghiere a un calendario chiamato Rhemn, per i prossimi 7 giorni, così nessuno prenota su di esse.",
      "prayerTimesOn": "Attivo. Aggiunte fino al {{date}}.",
      "prayerTimesWaiting": "In attesa di Google…",
      "prayerTimesDenied": "Google non lo ha consentito. Non è stato aggiunto nulla.",
      "prayerTimesRemoveAsk": "Rimuovere gli orari di preghiera di Rhemn dal tuo calendario?",
      "prayerTimesKeep": "Mantienili",
      "prayerTimesRemove": "Rimuovi",
      "meetingPrompts": "Suggerimenti per le riunioni",
      "meetingPromptsSub": "Quando una riunione con un link sta per iniziare, propone di prendere appunti.",
      "busyFootnote": "\"Pianifica la mia giornata\" vede solo quando sei impegnato, mai il contenuto delle tue riunioni.",
      "todoistFootnote": "Le priorità di Todoist diventano Critica, Alta, Media e Bassa. I sotto-task oltre il primo livello appaiono come passaggi sotto l'attività principale.",
      "reauth": "{{provider}} ha smesso di far sincronizzare Rhemn. Succede quando l'accesso viene revocato o la password cambia.",
      "reconnect": "Riconnetti",
      "paused": "La sincronizzazione è in pausa perché Rhemn Pro è terminato. Le tue liste restano come erano.",
      "calendarDenied": "L'accesso al calendario è disattivato.",
      "remindersDenied": "L'accesso ai promemoria è disattivato.",
      "disconnect": "Disconnetti {{provider}}",
      "disconnectTitle": "Disconnettere {{provider}}?",
      "disconnectBody": "Non viene eliminato nulla in {{provider}}.",
      "disconnectRhemnCal": "Il tuo calendario degli orari di preghiera di Rhemn verrà rimosso da Google Calendar.",
      "disconnectError": "Impossibile disconnettere {{provider}}. Riprova tra poco.",
      "keepLists": "Mantieni le mie liste in Rhemn",
      "keepListsSub": "Smettono di sincronizzarsi e diventano normali liste di Rhemn.",
      "removeLists": "Rimuovile da Rhemn",
      "removeListsSub": "Vengono rimosse solo le copie in Rhemn.",
      "disconnecting": "Disconnessione…",
      "appleStop": "Smetti di usare Calendario e Promemoria",
      "appleStopTitle": "Smettere di usare Calendario e Promemoria?",
      "appleStopBody": "Rhemn smette di mostrare i tuoi eventi e promemoria. Per rimuovere completamente il suo accesso, disattivalo nelle Impostazioni.",
      "justNow": "proprio ora",
      "tasksScope": "Rhemn ha bisogno del permesso per vedere le tue Google Tasks. Riconnetti e seleziona Attività per consentirlo.",
      "calendarsLoadError": "Impossibile caricare i tuoi calendari.",
      "calendarsEmpty": "Nessun calendario in questo account.",
      "calendarsScope": "Rhemn ha bisogno del permesso per vedere il tuo Google Calendar. Riconnetti e seleziona Calendar per consentirlo.",
      "prayerTimesError": "Impossibile aggiungere gli orari di preghiera. Riprova tra poco.",
      "remindersEmpty": "Nessuna lista in Promemoria.",
      "openSettings": "Apri Impostazioni",
      "appleStopCta": "Smetti di usare"
    },
    "locked": {
      "body": "Vedi le tue riunioni all'interno dei tuoi blocchi di preghiera e mantieni Google Tasks sincronizzato con Rhemn.",
      "googleName": "Google Calendar e Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "dispositivo"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, sincronizzata con {{provider}}",
      "unlinkConfirm": "Rimuovere «{{name}}» da Rhemn? Resterà in {{provider}}.",
      "remove": "Rimuovi",
      "offline": "Offline · Le modifiche si sincronizzeranno con {{provider}} al tuo ritorno.",
      "stillSyncing": "Ancora in sincronizzazione con {{provider}}…",
      "failed_one": "{{count}} modifica non è arrivata a {{provider}}.",
      "failed_many": "{{count}} modifiche non sono arrivate a {{provider}}.",
      "failed_other": "{{count}} modifiche non sono arrivate a {{provider}}.",
      "retry": "Riprova",
      "needsReconnect": "{{provider}} richiede che tu ti riconnetta.",
      "paused": "Sincronizzazione in pausa · Rhemn Pro è terminato.",
      "upgrade": "Passa a Pro",
      "notSynced": "Non sincronizzato",
      "notSynced_aria": "Non sincronizzato con {{provider}}. Riprova.",
      "remindersOff": "Rhemn non riesce a raggiungere Promemoria. Riattivalo nelle Impostazioni.",
      "dueToday": "Oggi",
      "dueTomorrow": "Domani",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Tutto il giorno",
      "more": "+{{count}}",
      "more_aria": "Mostra altri {{count}} eventi di tutto il giorno",
      "less_aria": "Mostra meno eventi di tutto il giorno",
      "events_aria": "Eventi",
      "event_aria": "Dalle {{start}} alle {{end}}, {{title}}",
      "allDayEvent_aria": "Tutto il giorno, {{title}}",
      "untitled": "Occupato",
      "now": "Ora · fino alle {{end}}",
      "until": "fino alle {{end}}",
      "into": "· fino a {{prayer}}",
      "loadError": "Impossibile caricare il tuo calendario.",
      "needsReconnect": "Google Calendar richiede una nuova connessione.",
      "scope": "Rhemn non può vedere il tuo Google Calendar. Riconnetti e seleziona Calendar per consentirlo.",
      "appleOff": "Rhemn non può vedere il tuo calendario. Riattivalo in Impostazioni."
    },
    "plan": {
      "mostlyMeetings": "Quasi tutto riunioni · {{duration}} liberi",
      "noFreeTime": "Nessun tempo libero",
      "aroundMeetings_one": "Pianificato attorno a {{count}} riunione.",
      "aroundMeetings_many": "Pianificato attorno a {{count}} riunioni.",
      "aroundMeetings_other": "Pianificato attorno a {{count}} riunioni.",
      "settledBusy": "È già tutto sistemato attorno alle tue riunioni."
    },
    "meeting": {
      "group_aria": "Riunione in partenza",
      "now": "ora",
      "takeNotes": "Prendi appunti",
      "takeNotes_aria": "Prendi appunti per {{title}}",
      "dismiss_aria": "Chiudi",
      "announce": "{{title}} inizia {{when}}.",
      "announceNow": "{{title}} sta iniziando ora.",
      "yourMeeting": "La tua riunione"
    },
    "apple": {
      "primer": {
        "title": "Mostra il calendario accanto alle preghiere",
        "body": "Rhemn legge eventi e promemoria su questo {{device}} per collocarli nella tua giornata. Restano sul tuo dispositivo. Pianifica la giornata usa solo gli orari in cui sei impegnato.",
        "cta": "Continua",
        "skip": "Non ora",
        "footnote": "{{device}} chiederà due volte, una per Calendario e una per Promemoria. Puoi modificarli entrambi in Impostazioni."
      }
    }
  }
}
